import { useNavigate } from 'react-router-dom';
import './AboutCTA.scss';

const AboutCTA = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/', { state: { scrollToContact: true } });
  };

  return (
    <section className="about-cta section">
      <div className='wrapper wrapper--medium centered'>
        <h2 className="wrapper__title">Quer transformar o seu negócio?</h2>
        <button onClick={handleClick} className="cta-filled centered">Fale Connosco</button>
        </div>
    </section>
  );
};

export default AboutCTA;